import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { uploadFiles } from 'src/app/shared/models/uploadFiles.model';
import { environment } from 'src/environments/environment';
import { ELearningManagementService } from '../e-learning-management.service';
import { ModalAddTopicComponent } from '../modal-add-topic/modal-add-topic.component';
import * as tus from 'tus-js-client';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { AccountingService } from '../../accounting/accounting.service';
import { LearningCenterService } from '../../learning-center/learning-center.service';

@Component({
  selector: 'app-manage-course',
  templateUrl: './manage-course.component.html',
  styleUrls: ['./manage-course.component.scss']
})
export class ManageCourseComponent implements OnInit {
  isLoading: boolean;
  isEdit: boolean;
  isAddLesson: boolean = false;
  courseForm: FormGroup;
  lessonForm: FormGroup;
  exVdo: string;
  exVdoUri: string;
  percentage: number;

  LESSON_DOC = [];
  activeTeacher;
  activeCoTeacher;
  activeCoTeacherCutSelected;
  courseType;
  coursePicFile: File;
  coursePic: string;
  courseId: string;
  courseSuggest;
  selectedAssitantTacher = [];
  allLesson: any;
  courseDetail;
  lessonDelete = [];
  lessonEdit = [];
  lessonEditDoc = [];
  lessonCreate = [];
  lessonCreateDoc = [];
  videoList: FileList;
  videoLinks = [];
  pendingFiles: uploadFiles[] = [];
  courseNumberSuccess: string = null;
  courseNumberError: string = null;

  account: any; //new

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    maxHeight: 'auto',
    width: '80%;',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'ใส่รายละเอียดคอร์สของคุณ',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  }

  taList = [];
  taSelectList = [];

  allLearningCenter: any[] = [];
  learningCenter: any;
  LN_TAG: any[] = [];

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private eLearningService: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService,
    private accountService: AccountingService,
    private learningCenterService: LearningCenterService,
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.isLoading = true;
    this.lessonForm = this.fb.group({
      LESSONS: this.fb.array([])
    });

    this.getAPI();
    this.getAllLearning();

    if (this.isEdit) {
      this.courseId = new URL(location.href).searchParams.get('course_id');
      this.gobalFunctionService.setTitle('แก้ไขคอร์สเรียน');

      this.eLearningService.getDetailCourseById(this.courseId).subscribe(res => {
        this.courseDetail = res.result[0];
        console.log(this.courseDetail);
        if (this.courseDetail.TA.length > 0) {
          this.courseDetail.TA.forEach(e => {
            this.taSelectList.push({
              USER_ID: e.TEACHER_ID,
              EMAIL: e.EMAIL,
            })
          });
        }

        // console.log(this.taSelectList);

        this.courseForm = this.fb.group({
          courseNumber: [this.courseDetail.COURSE_NUMBER, Validators.required],
          courseName: [this.courseDetail.COURSE_NAME, Validators.required],
          courseType: [this.courseDetail.COURSE_TYPE_NAME, Validators.required],
          teacherId: [this.courseDetail.TEACHER_ID, Validators.required],
          courseExapleVDO: [this.courseDetail.COURSE_VDO_EXAMPLE, Validators.required],
          teacherAssistant: [this.courseDetail.TEACHER_ASSISTANT],
          coursePic: [this.courseDetail.COURSE_PIC_ORIGINAL, Validators.required],
          coursePrice: [this.courseDetail.COURSE_PRICE, Validators.required],
          courseSpacialPrice: [this.courseDetail.COURSE_SPECIALPRICE, Validators.required],
          courseSuggest: [this.courseDetail.COURSE_SUGGESTION],
          courseCoinReward: this.courseDetail.COURSE_COIN_REWARD,
          courseCoinClose: this.courseDetail.COURSE_COIN_CLOSE,
          courseDateTime: [[this.courseDetail.COURSE_START, this.courseDetail.COURSE_END], Validators.required],
          courseDescrition: [this.courseDetail.COURSE_DESCRIPTION, Validators.required],
          openReview: [this.courseDetail.OPEN_REVIEW === "true" ? true : false, Validators.required], // new
          openChat: [this.courseDetail.OPEN_CHAT === "true" ? true : false, Validators.required], // new
          openPrivateChat: [this.courseDetail.OPEN_PRIVATECHAT === "true" ? true : false, Validators.required], // new
          taId: [''], //new
          accountId: [this.courseDetail.ACCOUNTING_ID, Validators.required], //new
          centerId: [this.courseDetail.LN_TAG],
        })
        this.coursePic = this.courseDetail.COURSE_PIC_ORIGINAL;
        this.exVdo = this.courseDetail.COURSE_VDO_EXAMPLE_NAME;
        this.exVdoUri = this.courseDetail.COURSE_VDO_EXAMPLE;
        this.LN_TAG = this.courseDetail.LN_TAG;
      })
    } else {
      this.gobalFunctionService.setTitle('สร้างคอร์สเรียน');

      this.courseForm = this.fb.group({
        courseNumber: ['', Validators.required],
        courseName: ['', Validators.required],
        courseType: ['', Validators.required],
        teacherId: ['', Validators.required],
        courseExapleVDO: ['', Validators.required],
        teacherAssistant: [''],
        coursePic: ['', Validators.required],
        coursePrice: ['', Validators.required],
        courseSpacialPrice: ['', Validators.required],
        courseSuggest: [''],
        courseCoinReward: [0],
        courseCoinClose: [0],
        courseDateTime: ['', Validators.required],
        courseDescrition: ['', Validators.required],
        // LESSONS: this.fb.array([])
        openReview: [true, Validators.required], // new
        openChat: [true, Validators.required], // new
        openPrivateChat: [true, Validators.required], // new
        taId: [''], //new
        accountId: ['', Validators.required], //new
        centerId: [''],
      })

      this.allLesson = [];
      this.addGroup();
    }
  }

  getAPI() {
    this.eLearningService.getActiveTeacher().pipe(
      switchMap(resTeacher => {
        this.activeTeacher = resTeacher.result;
        this.activeCoTeacherCutSelected = resTeacher.result;

        return this.eLearningService.getAllTypeCourse();
      }),
      switchMap(resTypeCourse => {
        this.courseType = resTypeCourse.result;
        return this.eLearningService.getSuggestCourse();
      }),
      switchMap(resSuggestCourse => {
        this.courseSuggest = resSuggestCourse.result;

        if (this.isEdit && this.courseId) {
          this.setGroup();
          this.selectTeacher(this.courseDetail.TEACHER_ID, true);
        }

        this.isLoading = false;
        return this.eLearningService.getActiveUser();
      }),
      switchMap(ta => {
        // console.log(ta);
        ta.result.forEach(e => {
          this.taList.push({
            USER_ID: e.USER_ID,
            EMAIL: e.EMAIL,
          })
        });
        return this.accountService.getActiveAccount().pipe(
          map(a => {
            // console.log(a.result);
            this.account = a.result;
          })
        )
        // console.log(this.taList);
      })
    ).subscribe();
  }

  addCourse(c, i) {
    // console.log(c);
    const dialogConfig = new MatDialogConfig();
    let body;

    this.isLoading = true;
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    body = {
      index: i,
      lesson: c,
      courseId: this.courseId,
      lessonId: this.allLesson[i]?.LESSON_ID ? this.allLesson[i].LESSON_ID : ''
    }


    this.eLearningService.createLesson(body).pipe(
      switchMap(r => {
        // console.log(r);
        this.isLoading = false;

        dialogConfig.data = {
          title: 'เพิ่มหัวข้อในบทเรียน',
          actionBtnText: 'เสร็จสิ้น',
          courseId: this.courseId,
          lessonId: r.result.LESSON_ID,
          index: i,
          courseName: this.courseForm.value.courseName,
          line: this.allLesson[i]?.TOPIC.length ? this.allLesson[i].TOPIC.length + 1 : 1,
          value: c,
          isEdit: false
        }

        if (r.success) {
          // ลบบทเรียนที่แก้ไข เพราะบันทึกแล้ว
          if (this.lessonCreate.length > 0) {
            const index = this.lessonCreate.findIndex(l => l.LESSON_INDEX === i)
            this.lessonCreate.splice(index, 1);
            this.lessonCreateDoc.splice(index, 1);
          }
          if (this.lessonEdit.length > 0) {
            const index = this.lessonEdit.findIndex(l => l.LESSON_ID === this.allLesson[i].LESSON_ID)
            if (index !== -1) {
              this.lessonEdit.splice(index, 1);
              this.lessonEditDoc.splice(index, 1);
            }
          }

          const modal = this.matDialog.open(ModalAddTopicComponent, dialogConfig);
          return modal.afterClosed().pipe(
            switchMap(res => {
              if (res.status) {
                return this.eLearningService.getLessonDetailByCourseId({ COURSE_ID: this.courseId }).pipe(
                  map(lessons => {

                    // หลังจากเพิ่มคอร์สแล้ว filter คอร์สที่ลบออก เพราะเรียก getLessonDetailByCourseId
                    this.allLesson = lessons.result.filter(lesson => !this.lessonDelete.includes(lesson.LESSON_ID));
                  })
                )
              } else {
                return of(null)
              }
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()

  }

  editCourse(c, i, lessonId, topicId, type, line) {
    // console.log(c);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'แก้ไขหัวข้อในบทเรียน',
      actionBtnText: 'เสร็จสิ้น',
      courseId: this.courseId,
      lessonId: lessonId,
      topicId: topicId,
      courseName: this.courseForm.value.courseName,
      lessonName: this.allLesson[i].LESSON_NAME,
      index: i,
      line: line + 1,
      value: c,
      type: type,
      isEdit: true
    }

    const modal = this.matDialog.open(ModalAddTopicComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          return this.eLearningService.getLessonDetailByCourseId({ COURSE_ID: this.courseId }).pipe(
            map(lessons => {
              // หลังจากแก้ไขคอร์สแล้ว filter คอร์สที่ลบออก เพราะเรียก getLessonDetailByCourseId
              this.allLesson = lessons.result.filter(lesson => !this.lessonDelete.includes(lesson.LESSON_ID));
            })
          )
        } else {
          return of(null)
        }
      })
    ).subscribe();
  }

  addLesson(c) {
    this.isLoading = true;
    // console.log(c);
    this.eLearningService.createCourse(c, this.exVdo, this.exVdoUri).subscribe(res => {
      // // console.log(res);
      if (res.success) {
        this.isLoading = false;
        this.isAddLesson = true;
        this.courseId = res.result.COURSE_ID;
      }
    })
  }

  onCoverSelected(e, courseForm) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.coursePic = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];
        this.coursePicFile = file;

        courseForm.patchValue({
          coursePic: file
        });
        courseForm.get('coursePic').updateValueAndValidity()
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  docChange(e, lessonForm, i) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'pdf' || fileType === 'xlsx' || fileType === 'csv') {
      if (e.target.files && e.target.files[0]) {
        const file = (e.target as HTMLInputElement).files[0];

        this.LESSON_DOC[i] = e.target.files[0].name;

        if (this.isEdit && this.courseId) {
          lessonForm.controls['LESSON_DOC'].setValue(file);
        } else {
          lessonForm.patchValue({
            LESSON_DOC: file
          });
          lessonForm.get('LESSON_DOC').updateValueAndValidity()
        }
        // // console.log(lessonForm.value);
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ CSV, XLSX, PDF เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  setGroup() {
    return this.eLearningService.getLessonDetailByCourseId({ COURSE_ID: this.courseId }).pipe(
      map(lessons => {
        this.allLesson = lessons.result;
        // console.log(lessons);

        // console.log(this.allLesson);

        this.allLesson.forEach((e, i) => {
          this.LESSON_DOC[i] = e.LESSON_DOC_ORIGINAL;
          this.lessonForm.get('LESSONS')['controls'].push(this.fb.group({
            LESSON_NAME: [e.LESSON_NAME, Validators.required],
            LESSON_DOC: [e.LESSON_DOC_ORIGINAL],
            TOPICS: this.fb.array([])
          }))
          e.TOPIC.forEach((t) => {
            this.lessonForm.get('LESSONS')['controls'][i].get('TOPICS').push(this.fb.group({
              TOPIC_ID: [t.TOPIC_ID, Validators.required],
              TOPIC_NAME: [t.TOPIC_NAME, Validators.required],
              TOPIC_TYPE: [t.TOPIC_TYPE, Validators.required]
            }))
          })
        })
      })
    ).subscribe()

  }

  saveDraft(c, l) {
    // console.log(c);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'ยืนยันการบันทึก',
      description: `คุณต้องการบันทึกคอร์สเรียน ${c.courseName} ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
    }

    // ลบ lessonCreateDoc ที่ไม่มีค่าออก
    this.lessonCreateDoc = this.lessonCreateDoc.filter(lessonDoc => lessonDoc.LESSON_INDEX);

    const body = {
      COURSE_ID: this.courseId,
      COURSE_NUMBER: c.courseNumber,
      COURSE_NAME: c.courseName,
      COURSE_TYPE_NAME: c.courseType,
      TEACHER_ID: c.teacherId,
      TEACHER_ASSISTANT: c.teacherAssistant,
      COURSE_VDO_EXAMPLE: this.exVdoUri,
      COURSE_VDO_EXAMPLE_NAME: this.exVdo,
      COURSE_PRICE: c.coursePrice,
      COURSE_PIC: this.coursePicFile,
      COURSE_SPECIALPRICE: c.courseSpacialPrice,
      COURSE_COIN_REWARD: c.courseCoinReward,
      COURSE_COIN_CLOSE: c.courseCoinClose,
      COURSE_START: c.courseDateTime[0],
      COURSE_END: c.courseDateTime[1],
      COURSE_DESCRIPTION: c.courseDescrition,
      COURSE_SUGGESTION: c.courseSuggest,
      LESSON_EDIT: this.lessonEdit,
      LESSON_DEL: this.lessonDelete,
      LESSON_DOC: this.lessonEditDoc,
      LESSON_CREATE: this.lessonCreate,
      LESSON_CREATE_DOC: this.lessonCreateDoc,
      OPEN_REVIEW: c.openReview, // new
      OPEN_CHAT: c.openChat, // new
      OPEN_PRIVATECHAT: c.openPrivateChat, // new
      TA_ID: c.taId, // new
      ACCOUNTING_ID: c.accountId, // new
      CENTER_ID: c.centerId
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          this.isLoading = true
          return this.eLearningService.saveDraftCourse(body).pipe(
            switchMap(res2 => {
              if (res2.success) {
                this.isLoading = false;
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalSuccess';
                dialogConfig2.width = '400px';
                dialogConfig2.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกคอร์สเรียน ${c.courseName} สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }
                const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);
                return modal2.afterClosed().pipe(
                  map(res3 => {
                    if (!res3) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close()
                      }, 100);
                    }
                  })
                )
              }
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }


  createCourse(c) {
    // console.log(c);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'ยืนยันการสร้าง',
      description: `คุณต้องการสร้างคอร์สเรียน ${c.courseName} ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
    }

    // ลบ lessonCreateDoc ที่ไม่มีค่าออก
    this.lessonCreateDoc = this.lessonCreateDoc.filter(lessonDoc => lessonDoc.LESSON_INDEX);

    const body = {
      COURSE_ID: this.courseId,
      COURSE_NUMBER: c.courseNumber,
      COURSE_NAME: c.courseName,
      COURSE_TYPE_NAME: c.courseType,
      TEACHER_ID: c.teacherId,
      TEACHER_ASSISTANT: c.teacherAssistant,
      COURSE_VDO_EXAMPLE: this.exVdoUri,
      COURSE_VDO_EXAMPLE_NAME: this.exVdo,
      COURSE_PRICE: c.coursePrice,
      COURSE_PIC: this.coursePicFile,
      COURSE_SPECIALPRICE: c.courseSpacialPrice,
      COURSE_COIN_REWARD: c.courseCoinReward,
      COURSE_COIN_CLOSE: c.courseCoinClose,
      COURSE_START: c.courseDateTime[0],
      COURSE_END: c.courseDateTime[1],
      COURSE_DESCRIPTION: c.courseDescrition,
      COURSE_SUGGESTION: c.courseSuggest,
      LESSON_EDIT: this.lessonEdit,
      LESSON_DEL: this.lessonDelete,
      LESSON_DOC: this.lessonEditDoc,
      LESSON_CREATE: this.lessonCreate,
      LESSON_CREATE_DOC: this.lessonCreateDoc,
      OPEN_REVIEW: c.openReview, // new
      OPEN_CHAT: c.openChat, // new
      OPEN_PRIVATECHAT: c.openPrivateChat, // new
      TA_ID: c.taId, // new
      ACCOUNTING_ID: c.accountId, // new
      CENTER_ID: c.centerId,
    }

    // console.log(body);

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          this.isLoading = true
          return this.eLearningService.confirmCreateCourse(body).pipe(
            switchMap(res2 => {
              if (res2.success) {
                this.isLoading = false;
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalSuccess';
                dialogConfig2.width = '400px';
                dialogConfig2.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">สร้างคอร์สเรียน ${c.courseName} สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);
                return modal2.afterClosed().pipe(
                  map(res3 => {
                    if (!res3) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close()
                      }, 100);
                    }
                  })
                )
              }
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }

  onChange(c, i, e?) {
    if (e) {
      if (e.target.type === 'file' && this.allLesson[i]?.LESSON_ID) {
        // รอลบถ้าไม่มีบัค if (e.target.type === 'file' && this.allLesson[i]?.LESSON_ID !== null && this.allLesson[i]?.LESSON_ID !== undefined) {

        const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

        if (fileType === 'pdf' || fileType === 'xlsx' || fileType === 'csv') {
          if (e.target.files && e.target.files[0]) {
            if (this.lessonEdit.length > 0) {
              const index = this.lessonEdit.findIndex(e => e.LESSON_ID === this.allLesson[i].LESSON_ID)
              // // console.log(index);
              if (index !== -1) {
                this.lessonEditDoc[index] = {
                  LESSON_ID: this.allLesson[i].LESSON_ID,
                  LESSON_DOC: c.LESSON_DOC
                };
                this.lessonEdit[index] = {
                  LESSON_ID: this.allLesson[i].LESSON_ID,
                  LESSON_DOC: c.LESSON_DOC.name,
                  LESSON_NAME: c.LESSON_NAME,
                  EDIT_FILE: true
                }
              } else {
                this.lessonEditDoc.push({
                  LESSON_ID: this.allLesson[i].LESSON_ID,
                  LESSON_DOC: c.LESSON_DOC
                });
                this.lessonEdit.push({
                  LESSON_ID: this.allLesson[i].LESSON_ID,
                  LESSON_DOC: c.LESSON_DOC.name,
                  LESSON_NAME: c.LESSON_NAME,
                  EDIT_FILE: true
                })
              }
            } else {
              this.lessonEditDoc.push({
                LESSON_ID: this.allLesson[i].LESSON_ID,
                LESSON_DOC: c.LESSON_DOC
              });

              this.lessonEdit.push({
                LESSON_ID: this.allLesson[i].LESSON_ID,
                LESSON_DOC: c.LESSON_DOC.name,
                LESSON_NAME: c.LESSON_NAME,
                EDIT_FILE: true
              })
            }
            // // console.log(this.lessonEditDoc);
            // // console.log(this.lessonEdit);
          }
        }
      } else if (e.target.type === 'text' && this.allLesson[i]?.LESSON_ID) {
        // รอลบถ้าไม่มีบัค } else if (e.target.type === 'text' && this.allLesson[i]?.LESSON_ID !== null && this.allLesson[i]?.LESSON_ID !== undefined) {
        // // console.log(this.allLesson[i].LESSON_ID);
        if (this.lessonEdit.length > 0) {
          const index = this.lessonEdit.findIndex(e => e.LESSON_ID === this.allLesson[i].LESSON_ID);
          // // console.log(index);
          if (index !== -1) {
            if (this.lessonEdit[index].EDIT_FILE) {
              this.lessonEdit[index] = {
                LESSON_ID: this.allLesson[i].LESSON_ID,
                LESSON_DOC: c.LESSON_DOC,
                LESSON_NAME: c.LESSON_NAME,
                EDIT_FILE: true
              }
            } else {
              this.lessonEdit[index] = {
                LESSON_ID: this.allLesson[i].LESSON_ID,
                LESSON_DOC: c.LESSON_DOC,
                LESSON_NAME: c.LESSON_NAME,
                EDIT_FILE: false
              }
            }
          } else {
            this.lessonEdit.push({
              LESSON_ID: this.allLesson[i].LESSON_ID,
              LESSON_DOC: c.LESSON_DOC,
              LESSON_NAME: c.LESSON_NAME,
              EDIT_FILE: false
            })
          }
        } else {
          this.lessonEdit.push({
            LESSON_ID: this.allLesson[i].LESSON_ID,
            LESSON_DOC: c.LESSON_DOC,
            LESSON_NAME: c.LESSON_NAME,
            EDIT_FILE: false
          })
        }
      } else if (!this.allLesson[i]?.LESSON_ID) {
        // รอลบถ้าไม่มีบัค } else if (this.allLesson[i]?.LESSON_ID === null || this.allLesson[i]?.LESSON_ID === undefined) {
        const index = this.lessonCreate.findIndex(e => e.LESSON_INDEX === i);
        if (index !== -1) {
          this.lessonCreateDoc[index] = {
            LESSON_DOC: c.LESSON_DOC,
            LESSON_INDEX: i
          }

          this.lessonCreate[index] = {
            LESSON_DOC: c.LESSON_DOC.name,
            LESSON_NAME: c.LESSON_NAME,
            LESSON_INDEX: i
          }
        } else {
          this.lessonCreate.push({
            LESSON_DOC: c.LESSON_DOC,
            LESSON_NAME: c.LESSON_NAME,
            LESSON_INDEX: i
          })
        }
      }
    }
  }

  checkCourseNumber(e) {
    const body = {
      COURSE_ID: this.courseId ? this.courseId : '',
      COURSE_NUMBER: e.target.value
    }

    this.eLearningService.validateCourseNumber(body).subscribe(res => {
      this.courseNumberSuccess = res.message;
      this.courseNumberError = null;
    }, err => {
      this.courseNumberSuccess = null;
      this.courseNumberError = err.error.message;
    })
  }

  addGroup() {
    (<FormArray>this.lessonForm.get("LESSONS")).push(this.fb.group({
      LESSON_NAME: ['', Validators.required],
      LESSON_DOC: [''],
      TOPICS: this.fb.array([])
    }))
  }

  removeGroup(index) {
    if (this.allLesson[index]?.LESSON_ID !== undefined) {
      if (this.lessonEdit.length > 0) {
        const i = this.lessonEdit.findIndex(l => l.LESSON_ID === this.allLesson[index].LESSON_ID)
        // // console.log(i);

        if (index !== -1) {
          this.lessonEditDoc.splice(i, 1);
          this.lessonEdit.splice(i, 1);
        }
      }
      this.lessonDelete.push(this.allLesson[index].LESSON_ID);
      this.lessonForm.value.LESSONS.splice(index, 1);
      this.LESSON_DOC.splice(index, 1);
      this.allLesson = this.allLesson.filter((e => this.allLesson[index].LESSON_ID !== e.LESSON_ID));
    } else {
      const k = this.lessonCreate.findIndex(l => l.LESSON_INDEX === index)
      this.lessonCreate.splice(k, 1);
      this.lessonCreateDoc.splice(k, 1);
      this.lessonForm.value.LESSONS.splice(k, 1);
    }

    (<FormArray>this.lessonForm.get("LESSONS")).removeAt(index);
  }


  vdoChange(e, courseForm) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'mp4') {
      if (e.target.files && e.target.files[0]) {
        const file = (e.target as HTMLInputElement).files[0];
        this.percentage = 0;
        this.exVdo = e.target.files[0].name;
        this.eLearningService.createVideo(file).pipe(
          map(response => {
            const videoFile = new uploadFiles(file, response.body.link, response.body.upload.upload_link);
            this.pendingFiles.push(videoFile);
            this.exVdoUri = response.body.uri.slice(8);
            // // console.log(response.body);

            return new tus.Upload(this.pendingFiles[0].video, {
              uploadUrl: this.pendingFiles[0].uploadURI,
              endpoint: this.pendingFiles[0].uploadURI,
              retryDelays: [0, 1000, 3000, 5000],
              onError: error => {
                // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                return of(null)
              },
              onProgress: (bytesUploaded, bytesTotal) => {
                this.percentage = ((bytesUploaded / bytesTotal) * 100);
                const percentage = ((bytesUploaded / bytesTotal) * 100);
                // // console.log(bytesUploaded, bytesTotal, percentage + '%');
              },
              onSuccess: () => {
                this.isLoading = false;

                courseForm.patchValue({
                  courseExapleVDO: file
                });
                courseForm.get('courseExapleVDO').updateValueAndValidity()
                // console.log('Videos uploaded successfully');
              }
            }).start();
          }),
        ).subscribe();
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ MP4 เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  deleteCourse(courseId) {
    this.isLoading = true;
    const confirmDelete = new MatDialogConfig();

    confirmDelete.autoFocus = false;
    confirmDelete.id = 'modalDeleteNews';
    confirmDelete.data = {
      title: 'คุณต้องการลบ Course?',
      description: `ระบบจะทำการลบ "${this.courseDetail.COURSE_NAME}" ออกจากระบบ คุณต้องการลบ ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      isDelete: true
    }

    const body = {
      COURSE_ID: courseId
    }

    const modalDelete = this.matDialog.open(ModalComponent, confirmDelete);
    modalDelete.afterClosed().pipe(
      switchMap(isDelete => {
        if (isDelete) {
          this.isLoading = false;
          return this.eLearningService.delCourseById(body).pipe(
            switchMap(res => {
              if (res.success) {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '350px';
                dialogConfig.data = {
                  title: 'ลบ Course สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ลบ "${this.courseDetail.COURSE_NAME}" สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close()
                      }, 100);
                    }
                  })
                )
              } else {
                alert(res.message);
                return of(null);
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      })
    ).subscribe()
  }

  // isFirst ใช้ในกรณีที่ดึงข้อมูลจาก backend มาครั้งแรกเท่านั้น เพราะการจัดเรียงข้อมูลไม่เหมือนกัน
  selectTeacher(e, isFirst?) {
    let arr = [...this.activeTeacher];
    if (isFirst) {
      this.activeCoTeacherCutSelected = arr.filter(t => e !== t.TEACHER_ID);
    } else {
      this.activeCoTeacherCutSelected = arr.filter(t => e.target.value !== t.TEACHER_ID);
      this.courseForm.controls['teacherAssistant'].reset();
    }
    // // console.log(this.activeCoTeacherCutSelected);

    // // console.log(e.target.value);
  }


  compareTeacherAssistant(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.TEACHER_ID === i2.TEACHER_ID : i1 === i2;
  }

  compareSuggestCourse(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.COURSE_ID === i2.COURSE_ID : i1 === i2;
  }

  patch(val) {
    let uidList = []
    // // console.log(val.listOfValue);
    val.listOfValue.forEach(e => {
      uidList.push(e.USER_ID)
    });
    // // console.log(uidList);
    this.courseForm.patchValue({
      taId: uidList
    });
    this.courseForm.get('taId').updateValueAndValidity();

    // // console.log(this.courseForm);
  }

  compareTA(i1: any, i2: any): boolean {
    // console.log(i1);
    // console.log(i2);
    return i1 && i2 ? i1.USER_ID === i2.USER_ID : i1 === i2;
  }

  getAllLearning() {
    this.learningCenterService.getAllLearningCenterAdmin().subscribe(
      res => {
        res.result.forEach(e => {
          this.allLearningCenter.push({
            CENTER_NAME: e.CENTER_NAME,
            CENTER_ID: e.CENTER_ID,
          })
        })
      });
  }

  patchLearning(val, form) {
    let value = [];
    value = val.listOfValue;
    // console.log(val);
    form.patchValue({
      centerId: value
    });
    form.get('centerId').updateValueAndValidity();
    // console.log(form.value);
  }

  compareLNFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.CENTER_ID === i2.CENTER_ID : i1 === i2;
  }
}
